import { GridFilter, GridFilterGroup } from "../model/grid.model";

const SWITCH_PRESENTATION = "switch";
const ON_VALUE_LC = "on";
const OFF_VALUE_LC = "off";

function hasOnlyOnFilterSelected(filterGroup: GridFilterGroup): boolean {
    const selectedFilters = filterGroup.filters?.filter(
        (filter) => filter.selected,
    );

    return (
        selectedFilters.length === 1 &&
        selectedFilters[0].name.toLowerCase() === ON_VALUE_LC
    );
}

/**
 * Indicate whether a filterGroup is a "switch"
 */
export function isSwitchFilter(filterGroup: GridFilterGroup): boolean {
    return filterGroup.presentation === SWITCH_PRESENTATION;
}

/**
 * Indicate whether a filterGroup with presentation "switch" is active
 *
 * A switch filter group is active if, and only if, its "On" filter is selected.
 */
export function isSwitchFilterActive(filterGroup: GridFilterGroup): boolean {
    return isSwitchFilter(filterGroup) && hasOnlyOnFilterSelected(filterGroup);
}

/**
 * Mutate provided filterGroup to set its active status
 *
 * @return the internal selected filter ("On" or "Off")
 */
export function setSwitchFilterActive(
    filterGroup: GridFilterGroup,
    active: boolean,
): GridFilter {
    const onFilter = filterGroup.filters.find(
        (filter) => filter.name.toLowerCase() === ON_VALUE_LC,
    )!;
    const offFilter = filterGroup.filters.find(
        (filter) => filter.name.toLowerCase() === OFF_VALUE_LC,
    )!;

    onFilter.selected = active;
    offFilter.selected = !active;

    return active ? onFilter : offFilter;
}
